import { PromptTemplate, RecommendationType } from './types';
import { taskPrompt } from './recommendations/task';
import { researchPrompt } from './recommendations/research';
import { pagePrompt } from './recommendations/page';
import { imagePrompt } from './recommendations/image';
import { projectPrompt } from './recommendations/project';

export class PromptRegistry {
  private static prompts = new Map<RecommendationType, PromptTemplate>();

  static {
    // Register all default prompts
    this.register(taskPrompt);
    this.register(researchPrompt);
    this.register(pagePrompt);
    this.register(imagePrompt);
    this.register(projectPrompt);
  }

  /**
   * Register a new prompt template
   */
  static register(prompt: PromptTemplate): void {
    this.prompts.set(prompt.type, prompt);
  }

  /**
   * Get a prompt template by type
   */
  static get(type: RecommendationType): PromptTemplate | undefined {
    return this.prompts.get(type);
  }

  /**
   * Get the template string for a recommendation type
   */
  static getTemplate(type: RecommendationType): string | undefined {
    return this.prompts.get(type)?.template;
  }

  /**
   * Get all registered prompt templates
   */
  static getAll(): PromptTemplate[] {
    return Array.from(this.prompts.values());
  }

  /**
   * Get all registered recommendation types
   */
  static getTypes(): RecommendationType[] {
    return Array.from(this.prompts.keys());
  }

  /**
   * Check if a recommendation type is registered
   */
  static has(type: RecommendationType): boolean {
    return this.prompts.has(type);
  }
} 